module.exports = __webpack_public_path__ + "img/tf.9043bf4b.svg";